/**
 * AWS console deep links for the admin dashboard — the ONE place these URLs
 * are built. Names are URL-encoded; region defaults to the app region.
 */
export const AWS_CONSOLE_REGION = 'us-west-2';

export type AwsConsoleResource = 'dynamodb' | 's3' | 'lambda' | 'ec2';

export function awsConsoleUrl(type: AwsConsoleResource, name: string, region: string = AWS_CONSOLE_REGION): string {
  const n = encodeURIComponent(name);
  const r = encodeURIComponent(region || AWS_CONSOLE_REGION);
  switch (type) {
    case 'dynamodb':
      return `https://${r}.console.aws.amazon.com/dynamodbv2/home?region=${r}#table?name=${n}`;
    case 's3':
      return `https://s3.console.aws.amazon.com/s3/buckets/${n}?region=${r}`;
    case 'lambda':
      return `https://${r}.console.aws.amazon.com/lambda/home?region=${r}#/functions/${n}`;
    case 'ec2':
      // `name` is the instance id (i-0123...).
      return `https://${r}.console.aws.amazon.com/ec2/home?region=${r}#InstanceDetails:instanceId=${n}`;
  }
}
